/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  /**
   * Коллекция вопрос-ответов в карточке товара
   */
  app.ItemQuestions = app.Collection.extend({
    
    model: app.ItemQuestion,
    url: function (options) {
      var url = app.entryScriptName + '/api/v3/item-question/';
      url += '?expand=answers';
      if (this.item_id) {
        url += '&item_id=' + this.item_id;
      }
      if (this.showAll) {
        url += '&per-page=0';
      } else {
        url += '&per-page=7';
      }
      return url;
    },
    /**
     * Добавление меты ответа к коллекции
     * @param response
     */
    parse: function (response) {
      this.state = response._meta;
      return response.items;
    },
    initialize: function (data) {
      this.state = {};
      app.Collection.prototype.initialize.apply(this);
    }
  });
})();

}.call(window));